export function initFooter(){
    //apply this script only on mobile
    if (window.innerWidth < 768) {
        footerMenuMobile();
    }
}

function footerMenuMobile() {
    const svgIcon = `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.25 6.875L10 13.125L3.75 6.875" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    `;
    document.querySelectorAll(".collapse-menu .footer-menu__title").forEach(title => {
        if (!title.querySelector('svg')) {
            title.insertAdjacentHTML("beforeend", svgIcon);
        }
        title.addEventListener("click", () => {
            title.classList.toggle("active");
            const panel = title.nextElementSibling;
            panel.style.maxHeight = panel.style.maxHeight ? null : panel.scrollHeight + "px";
        });
    });
}
